import React from "react";
import LoadingScreen from "../../../shared/components/LoadingScreen";
import { EditProductProps } from "./products/EditProduct/types/product";
import { useEditProduct } from "./products/EditProduct/hooks/useEditProduct";
import { useFormHandlers } from "./products/EditProduct/hooks/useFormHandlers";
import EditProductFields from "./products/EditProduct/components/EditProductFields";
import EditProductActions from "./products/EditProduct/components/EditProductActions";
import { ModalWrapper } from "src/shared/components/ModalWrapper"; // ✅ adjust path if needed

const EditProduct: React.FC<EditProductProps> = (props) => {
  const editHook = useEditProduct(props);
  const formHandlers = useFormHandlers({
    formData: editHook.formData,
    handleInputChange: editHook.handleInputChange,
    removeEmojis: editHook.removeEmojis,
    formatAmount: editHook.formatAmount,
  });

  const isUpdateEnabled = editHook.hasChanges && editHook.isFormValid && !editHook.isLoading;

  // ✅ Use null when not open
  if (!props.open) return null;

  return (
    <ModalWrapper title="Edit Product" onClose={props.onClose} showCloseButton width="max-w-xl" useTheme>
      <div className="space-y-6">
        <EditProductFields
          {...{
            ...editHook,
            ...formHandlers,
            businessType: props.businessType,
            getCategoryInitials: editHook.getCategoryInitials,
            updateProductNameWithCategory: editHook.updateProductNameWithCategory,
          }}
        />

        <EditProductActions onClose={props.onClose} onUpdate={editHook.handleUpdate} isUpdateEnabled={isUpdateEnabled} />
      </div>

      {editHook.isLoading && <LoadingScreen />}
      {/* <ToastContainer position="top-right" autoClose={3000} hideProgressBar={false} newestOnTop={false} closeOnClick pauseOnHover /> */}
    </ModalWrapper>
  );
};

export default EditProduct;
